import { create } from 'zustand';

type View = 'inbox' | 'thread' | 'inquiry';

interface OpenOpts {
	conversationId?: string | null;
	inquiryId?: string | null;
}

interface ChatStore {
	isOpen: boolean;
	isMinimized: boolean;
	view: View;
	activeConversationId: string | null;
	activeInquiryId: string | null;
	/** Optional subject pre-selected for the team thread (e.g. /contact?subject=Partnership). */
	pendingSubject: string | null;
	open: (opts?: OpenOpts) => void;
	openTeamThread: (subject?: string) => void;
	goInbox: () => void;
	setActiveConversation: (id: string | null) => void;
	setActiveInquiry: (id: string | null) => void;
	clearPendingSubject: () => void;
	minimize: () => void;
	restore: () => void;
	close: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
	isOpen: false,
	isMinimized: false,
	view: 'inbox',
	activeConversationId: null,
	activeInquiryId: null,
	pendingSubject: null,
	open: (opts) =>
		set({
			isOpen: true,
			isMinimized: false,
			view: opts?.inquiryId ? 'inquiry' : opts?.conversationId ? 'thread' : 'inbox',
			activeConversationId: opts?.conversationId ?? null,
			activeInquiryId: opts?.inquiryId ?? null,
		}),
	openTeamThread: (subject) =>
		set({
			isOpen: true,
			isMinimized: false,
			view: 'thread',
			activeConversationId: 'team',
			activeInquiryId: null,
			pendingSubject: typeof subject === 'string' && subject.trim() ? subject.trim() : null,
		}),
	goInbox: () => set({ view: 'inbox', activeConversationId: null, activeInquiryId: null }),
	setActiveConversation: (id) =>
		set({
			view: id ? 'thread' : 'inbox',
			activeConversationId: id,
			activeInquiryId: null,
		}),
	setActiveInquiry: (id) =>
		set({
			view: id ? 'inquiry' : 'inbox',
			activeInquiryId: id,
			activeConversationId: null,
		}),
	clearPendingSubject: () => set({ pendingSubject: null }),
	minimize: () => set({ isMinimized: true }),
	restore: () => set({ isMinimized: false }),
	close: () =>
		set({
			isOpen: false,
			isMinimized: false,
			view: 'inbox',
			activeConversationId: null,
			activeInquiryId: null,
			pendingSubject: null,
		}),
}));
